module.exports = __webpack_public_path__ + "static/media/DemandPlanningUseCase.1e5fe28c.png";